export default __webpack_public_path__ + "static/media/HomeAndGarden.0a349e47.svg";